import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMaxPriceService } from "../../services/product.service";

export const getMaxPrice = createAsyncThunk(
  "getMaxPrice",
  async (params, { rejectWithValue }) => {
    return await getMaxPriceService(params, rejectWithValue);
  }
);
